<template>
	<card>
		<template slot="header">
			<h5 v-if="$slots.title || title" class="card-title">
				<slot name="title">
					{{ title }}
				</slot>
			</h5>
		</template>
		<div>
			<div class="container-fluid">
				<div class="row">
					<div style="margin: 0 auto">
						<div class="switch-info align-items-center">
							<span
								class="chart-type pt-2"
								:class="{ 'active-chart': viewType == false }"
								>Line Chart</span
							>
							<label class="switch">
								<input
									type="checkbox"
									@change="changeView($event)"
									v-model="viewType"
								/>
								<span class="slider"></span>
							</label>
							<span
								class="chart-type pt-2"
								:class="{ 'active-chart': viewType == true }"
								>Bar Chart</span
							>
							<div style="display: flex;">
								<div style="margin: 10px auto 0 auto;">
									<div style="display: flex; padding: 3px 10px 0px 5px; gap:10px;">
										<div> Energy / Wh </div>
										<div>
											<toggle-button v-model="viewUnit"
														color="#20bfaa"
														:width="50"
														@change="changeViewUnit"/>
										</div>
										<div> Power / W </div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row card-group" v-if="periodTime == 'today' && !viewType">
					<div class="text-center col-lg-3 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title1" class="kpi-title">So Far Today</h4>
							<div id="co-tablecell-value1" class="kpi-content">
								{{ currentTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title2" class="kpi-title">
								So Far This Week
							</h4>
							<div id="co-tablecell-value2" class="kpi-content">
								{{ currentWeekTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title3" class="kpi-title">
								Predict This Week
							</h4>
							<div id="co-tablecell-value3" class="kpi-content">
								{{ predictWeekTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6">
						
						<div class="card-block" style="position: relative;">
							<h4 id="co-tablecell-title4" class="kpi-title">
								{{ consumptionName }}
							</h4>
							<div v-if="consumptionLoading" style="position:absolute; top:80%; left:30%;">
								<vue-loaders-line-spin-fade-loader
									class="loading"
									color="white"
									scale="0.5"
								/>
							</div>
							<div id="co-tablecell-value4" class="kpi-content"  v-else>
								{{ consumption }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>
				<div class="row card-group" v-if="periodTime == 'month' && !viewType">
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title12" class="kpi-title">
								So Far This Month
							</h4>
							<div id="co-tablecell-value12" class="kpi-content">
								{{ currentTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title5" class="kpi-title">
								Predict This Month
							</h4>
							<div id="co-tablecell-value5" class="kpi-content">
								{{ predictTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title13" class="kpi-title">
								Selected Period Consumption
							</h4>
							<div v-if="consumptionLoading" style="position:absolute; top:80%; left:30%;">
								<vue-loaders-line-spin-fade-loader
									class="loading"
									color="white"
									scale="0.5"
								/>
							</div>
							<div id="co-tablecell-value13" class="kpi-content"  v-else>
								{{ consumption }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>
				<div class="row card-group" v-if="periodTime == 'year' && !viewType">
					<div class="text-center col-lg-4 col-md-4 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title6" class="kpi-title">
								So Far This Year
							</h4>
							<div id="co-tablecell-value6" class="kpi-content">
								{{ currentTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-4 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title7" class="kpi-title">
								Predict This Year
							</h4>
							<div id="co-tablecell-value8" class="kpi-content">
								{{ predictTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-4 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title14" class="kpi-title">
								Special Period
							</h4>
							<div v-if="consumptionLoading" style="position:absolute; top:80%; left:30%;">
								<vue-loaders-line-spin-fade-loader
									class="loading"
									color="white"
									scale="0.5"
								/>
							</div>
							<div id="co-tablecell-value14" class="kpi-content" v-else>
								{{ consumption }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>

				<div class="row card-group" v-if="periodTime == 'today' && !!viewType">
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title21" class="kpi-title">So Far Today</h4>
							<div id="co-tablecell-value21" class="kpi-content">
								{{ currentTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title22" class="kpi-title">
								So Far This Week
							</h4>
							<div id="co-tablecell-value22" class="kpi-content">
								{{ currentWeekTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title23" class="kpi-title">
								Predict This Week
							</h4>
							<div id="co-tablecell-value23" class="kpi-content">
								{{ predictWeekTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>
				<div class="row card-group" v-if="periodTime == 'month' && !!viewType">
					<div class="text-center col-lg-6 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title32" class="kpi-title">
								So Far This Month
							</h4>
							<div id="co-tablecell-value32" class="kpi-content">
								{{ currentTotal }}{{ getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-6 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title35" class="kpi-title">
								Predict This Month
							</h4>
							<div id="co-tablecell-value35" class="kpi-content">
								{{ predictTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>
				<div class="row card-group" v-if="periodTime == 'year' && !!viewType">
					<div class="text-center col-lg-6 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title46" class="kpi-title">
								So Far This Year
							</h4>
							<div id="co-tablecell-value46" class="kpi-content">
								{{ currentTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
					<div class="text-center col-lg-6 col-md-6 col-sm-6">
						<div class="card-block">
							<h4 id="co-tablecell-title47" class="kpi-title">
								Predict This Year
							</h4>
							<div id="co-tablecell-value48" class="kpi-content">
								{{ predictTotal }}{{getUnitString()}}
							</div>
						</div>
					</div>
				</div>

				<div v-if="viewType === true">
					<div class="row pl-5 pr-5 pt-5 pb-0 mb-4 time-control">
						<div
							class="col-xs-6 mr-4 ml-4 pl-1 pr-1"
							:class="{ active: activeIndex == 'current' }"
							id="a1"
							@click="setActive('current')"
						>
							{{ currentTitle }}
						</div>
						<div
							class="col-xs-6 mr-4 ml-4 pl-1 pr-1"
							:class="{ active: activeIndex == 'previous' }"
							id="a2"
							@click="setActive('previous')"
						>
							{{ previousTitle }}
						</div>
					</div>
					<div class="row pl-5 pr-5 pt-4">
						<div class="col-xl-4 offset-xl-4 col-lg-6 mb-3 text-center">
							<label class="label-info text-white">Usage By: &nbsp;</label>
							<select
								id="appliance-select"
								@change="selectField($event)"
								v-model="fieldName"
							>
								<option v-for="usage in usages" :value="usage.value">
									{{ usage.label }}
								</option>
							</select>
						</div>
						<div class="col-xl-4 col-lg-6">
							<div id="usage-power-info" class="card-block">
								<div>
									<p class="ct-title">{{ ctTitle }}</p>
									<p class="t-title">
										<!-- react-text: 22 -->Total<!-- /react-text -->
										<span id="elecvalue1" class="t-content"
											>{{ totalPower }} {{getUnitString()}}</span
										>
									</p>
									<p class="t-title">
										<!-- react-text: 22 -->Day<!-- /react-text -->
										<span id="elecvalue" class="t-content"
											>{{ dayTotalPower }} {{getUnitString()}}</span
										>
									</p>
									<p class="t-title">
										<!-- react-text: 25 -->Night<!-- /react-text -->
										<span id="gasvalue" class="t-content"
											>{{ nightTotalPower }} {{getUnitString()}}</span
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="row pr-5 pl-5">
						<vue-loaders-line-spin-fade-loader
							class="loading"
							color="white"
							scale="1.4"
							v-if="isLoading"
						/>
						<v-chart class="chart" :option="option" v-else />
					</div>
				</div>
				<div class="container-fluid" v-else>
					<div class="row pt-2 pb-0 mb-4 filter-panel">
						<div class="col-sm-8">
							<div class="row mt-2 mb-2">
								<div class="col-xl-4 mt-5" v-if="lineChartFields.length > 0">
									<multi-select
										:type="'circuit'"
										:options="lineChartFields"
										@checked="onCheck"
									></multi-select>
								</div>
								<div class="col-xl-4 mt-5">
									<select
										id="period-select"
										@change="selectPeriodTime($event)"
										v-model="timePeriod"
									>
										<option v-for="period in periods" :value="period.value">
											{{ period.label }}
										</option>
									</select>
								</div>
								<div class="col-xl-4 mt-5">
									<date-picker
										class="inline-block h-full"
										v-model="pickedDateRange"
										:attributes="attrs"
										is-range
										@input="selectSpecialPeriod"
									>
										<template v-slot="{ inputValue, togglePopover }">
											<div class="flex items-center" style="display:flex;">
												<button class="timepickerbutton" @click="togglePopover()">
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="16"
														height="16"
														fill="currentColor"
														class="bi bi-calendar"
														viewBox="0 0 16 16"
													>
														<path
															d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
														/>
													</svg>
												</button>
												<input
													:value="getValueTime(inputValue)"
													class="display-time"
													readonly
												/>
											</div>
										</template>
									</date-picker>
								</div>
								<div class="col-xl-4 mt-5">
									<button type="button" class="filter-action" @click="changeUnit=false;showResult()">
										Update Chart
									</button>
								</div>
								<div class="col-xl-4 mt-5">
									<button type="button" class="filter-action" @click="downloadCSV">
										Download CSV
									</button>
								</div>
								<div class="col-xl-4 mt-5" style="display: flex; padding: 3px 10px 0px 5px; gap:10px;">
									<div> Select All</div>
									<div>
										<toggle-button v-model="showAll"
												   color="#20bfaa"
												   :width="50"
												   @change="selectSeriesAll"/>
									</div>
									<div> Disselect All </div>
								</div>
							</div>
						</div>
						<div class="col-sm-4">
							<v-chart class="pie-chart" :option="pieOption"/>
						</div>
					</div>
					<div class="row pt-3 pb-5">
						<vue-loaders-line-spin-fade-loader
							class="loading"
							color="white"
							scale="1.4"
							v-if="isLineLoading"
						/>
						<v-chart ref="lineChart" class="line-chart" :option="lineOption" v-else />
					</div>
				</div>
			</div>
		</div>
	</card>
</template>
<script>
import Card from "./Card.vue";
import MultiSelect from "@/components/Inputs/multiSelectInput";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	DataZoomComponent,
	ToolboxComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import QuerySetting from "@/mixins/querySetting";
import OctoberData from "@/mixins/octoberData";
import SetDisplayTime from "@/mixins/setDisplayTime";
import { saveAs } from "file-saver";
import moment from 'moment';
import { format } from 'date-fns-tz';
use([
	CanvasRenderer,
	BarChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent,
	DataZoomComponent,
	ToolboxComponent,
]);

export default {
	name: "real-power-card",
	mixins: [QuerySetting, OctoberData, SetDisplayTime],
	props: {
		title: {
			type: String,
			default: "",
		},
	},
	components: {
		Card,
		VChart,
		MultiSelect,
	},
	computed: {
		...mapGetters({
			periodTime: "settime/getPeriodTime",
			currentDayPower: "influx/getCurrentDayPower",
			currentNightPower: "influx/getCurrentNightPower",
			prevDayPower: "influx/getPrevDayPower",
			prevNightPower: "influx/getPrevNightPower",
			beforePrevDayPower: "influx/getBeforePrevDayPower",
			beforePrevNightPower: "influx/getBeforePrevNightPower",
			predictDayPower: "influx/getPredictDayPower",
			predictNightPower: "influx/getPredictNightPower",
			user: "auth/getUser",
			defaultSiteId: 'auth/getDefaultSiteId',
			defaultSiteName: 'auth/defaultSiteName',
			selectedMapDay: 'settime/getSelectedDay'
		}),
	},
	data() {
		return {
			consumptionName: 'All Devices Consumption',
			isLoading: true,
			sph: 60,
			specialTimePeriod: false,
			isLineLoading: true,
			currentTitle: "today",
			pickedDateRange: "",
			viewType: false,
			timePeriod: "last",
			previousTitle: "yesterday",
			activeIndex: "current",
			currentTotal: 0,
			currentWeekTotal: 0,
			predictWeekTotal: 0,
			predictTotal: 0,
			consumption: 0,
			ctTitle: "so far today",
			CSVData: [],
			totalPower: 0,
			dayTotalPower: 0,
			nightTotalPower: 0,
			fieldName: "overall",
			showAll: false,
			consumptionLoading: false,
			viewUnit: false,
			changeUnit: false,
			consumptionData: [],
			powerData: [],
			attrs: [
				{
					key: 'today',
    				highlight: true,
					dates: new Date(),
				}
			],
			tariff: {
				day: 0,
				night: 0,
				gen: 0
			},
			previousDayDisplayData: [],
			currentDayDisplayData: [],
			previousNightDisplayData: [],
			currentNightDisplayData: [],
			devices: [],
			weekPower: [],
			changePeriod: false,
			changeCustomSectionSetting: false,
			firstLoading:true,
			monthNames: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec",
			],
			lineChartFields: [],
			lineChartData: [],
			periods: [
				{ value: "last", label: "View Last..." },
				{ value: "6hours", label: "6 hours" },
				{ value: "day", label: "Day" },
				{ value: "2days", label: "2 Days" },
				{ value: "week", label: "Week" },
				{ value: "month", label: "Month" },
				{ value: "year", label: "Year" },
			],
			usages: [{value: 'overall', label: 'Overall'}],
			groupCircuits: [],
			lineOption: {
				title: {
					left: "center",
					text: "",
					textStyle: {
						color: "#FDFDFD",
						fontSize: 16,
						fontWeight: 100,
					},
				},
				toolbox: {
					show: true,
					orient: "horizontal",
					itemSize: 18,
					itemGap: 10,
					iconStyle: {
						borderColor: "#58E2C2",
					},
					feature: {
						saveAsImage: {
							show: true,
							title: "Save As Image",
						},
						dataView: {
							show: true,
							title: "Data View",
							optionToContent: function(opt) {
								let series = opt.series;
								let table = '<table style="width:100%;text-align:center;color:black;"><tbody>';

								for (let i = 0; i < series.length; i ++) {
									for (let j = 0; j < series[i].data.length; j ++) {
										table +='<tr><td>' + series[i].data[j][0] + '</td>';
										table +='<td>' + series[i].data[j][1] + '</td>';
										table += '<td>' + series[i].name + '</td></tr>';
									}
								}

								table += '</tbody></table>';
								return table;
							},
						},
						dataZoom: {
							show: true,
							title: {
								zoom: "Area Zoom",
								back: "Restore Area Zoom",
							},
						},
						restore: {
							show: true,
							title: "Restore",
						},
					},
					right: 10,
				},
				dataZoom: [
					{
						type: 'inside',
						xAxisIndex: [0],
						start: 0,
						end: 100
					},
					{
						type: 'inside',
						yAxisIndex: [0, 2],
						start: 0,
						end: 100
					}
				],
				tooltip: {
					show: true,
					position: "top",
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					showDelay: 0,
					textStyle: {
						color: "white",
					},
				},
				xAxis: {
					type: "time",
					axisLabel: {
						show: true,
						textStyle: {
							color: "white",
							fontSize: "12px",
							fontWeight: 200,
							fontFamily: "Nunito Sans Light",
						},
					},
					axisLine: {
						lineStyle: {
							type: "dashed",
						},
					},
					splitLine: {
						lineStyle: {
							color: "rgba(255, 255, 255, 0.3)",
							type: "dashed",
							width: 1,
						},
					},
					splitNumber: 10,
					axisTick: {
						show: true,
					},
				},
				yAxis: [],
				grid: {
					width: "80%",
					height: "60%",
					top: "5%",
					left: "13%",
				},
				legend: {
					bottom: "16%",
					data: [],
					borderColor: "#FDFDFD",
					borderWidth: 0.5,
					borderRadius: 5,
					textStyle: {
						color: "#FDFDFD",
					},
					padding: 10,
					icon: "rect",
					itemWidth: 10,
					itemHeight: 10,
					selectedMode: true,
				},
				series: [],
			},
			option: {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: "white",
					},
				},
				legend: {
					itemWidth: 13,
					itemHeight: 13,
					itemGap: 30,
					textStyle: {
						color: "white",
					},
					borderRadius: 0,
					bottom: 0,
				},
				color: ["#ADD8E6", "#800000"],
				grid: {
					left: "2%",
					right: "4%",
					bottom: "6%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "time",
						axisLabel: {
							show: true,
							textStyle: {
								color: "white",
								fontSize: "12px",
								fontWeight: 200,
								fontFamily: "Nunito Sans Light",
							},
							formatter: function (value, index) {
       							return format(value, 'yyyy-mm-dd HH:mm:ss', { timeZone : 'Europe/London' });
							}
						},
						axisLine: {
							lineStyle: {
								type: "solid",
								width: 6,
								borderColor: "red",
							},
						},
						axisTick: {
							show: false,
						},
					},
				],
				yAxis: [
					{
						type: "value",
						axisLabel: {
							show: true,
							color: "white"
						},
						splitLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
								type: "dashed",
								width: 1,
							},
						},
						splitNumber: 5,
						axisLine: {
							show: true,
							lineStyle: {
								width: 1,
							},
						},
					},
				],
				series: [
					{
						name: "Day",
						type: "bar",
						emphasis: {
							focus: "series",
						},
						data: [],
					},
					{
						name: "Night",
						type: "bar",
						emphasis: {
							focus: "series",
						},
						data: [],
					},
				],
			},
			pieOption: {
				tooltip: {
					show: true,
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				series: [
					{
						type: "pie",
						showEmptyCircle: false,
						label: {
							show: false
						},
						labelLine: {
							show: false
						},
						data:[]
					}
				]
			},
		};
	},
	watch: {
		async periodTime(newValue) {
			let time = '';
			this.changePeriod = true;
			if (this.periodTime == 'month') time ='pMonth';
			if (this.periodTime == 'year') time ='pYear';
			if (this.periodTime == 'today') time ='today';
			this.consumptionLoading = true;
			this.specialTimePeriod = false;

			await this.getTariff(this.user.siteId);
			this.runDisplay();
			await this.getRealTimeData();
			this.changeTitle(this.periodTime);
			this.changeXAxisLabel(time);
			this.showResult();
		},
		async defaultSiteId(newValue) {
			this.consumptionLoading = true;
			this.specialTimePeriod = false;
			await this.getTariff(this.user.siteId);
			this.runDisplay();
			await this.getRealTimeData();
			this.changeTitle(this.periodTime);
			this.showResult();
		},
		viewUnit(newValue) {
			this.consumptionLoading = true;
			this.changeTooltipUnit();
			this.showResult();
			this.getRealTimeData();
		}
	},
	async created() {
		let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site;
		let groupCircuits = await this.getGroupCircuits(this.user.siteId);
		if (groupCircuits.length > 0) {
			this.groupCircuits = groupCircuits;
			groupCircuits.forEach(group => {
				this.lineChartFields.push({
					useDevice: false, 
					field: group['devices'], 
					label: group['name'],
					type: 'Group',
				});
			})
		}

		if (this.user.devices.length > 0) {
			this.user.devices.map(device => {
				if (device.device_show === '1') {
					this.lineChartFields.push({
						useDevice:device.device_type !== 'Voltage' && device.device_type !== 'Frequency'? true: false, 
						field: "device_" + device['device_order'], 
						label: device['device_name'],
						type: device.device_type
					});

				}
			});
		}

		if (site === 'Brook Green' || site === 'Brook Green Updated') {
			this.usages = [
				{ value: "kitchen", label: "Kitchen" },
				{ value: "mbport", label: "MB Port" },
				{ value: "electrak", label: "Electrak" },
				{ value: "ac", label: "A/C Roof Comms Room" },
				{ value: "light", label: "Lights" },
				{ value: "overall", label: "Overall" },
			];
		} else {
			this.user.devices.forEach(device => {
				if (
					device.device_type !== 'Frequency' &&
					device.device_type !== 'Voltage' &&
					device.device_show === '1'
				) {
					this.usages.push(
						{value: device.device_name, label: device.device_name}
					)
				}
			});
		}
	},
	async mounted() {
		
		await this.getTariff(this.user.siteId);
		this.runDisplay();
		await this.getRealTimeData();
		this.changeTitle(this.periodTime);
		this.changeTooltipUnit();
		this.showResult();
		let time = '';
		if (this.periodTime == 'month') time ='pMonth';
		if (this.periodTime == 'year') time ='pYear';
		if (this.periodTime == 'today') time ='today';
		this.changeXAxisLabel(time);
		this.firstLoading = false;
	},
	methods: {
		...mapActions({
			getDisplayData: "influx/getDisplayData",
			getData: "influx/getInfluxData",
			getWeekData: "influx/getWeekData",
			getRates: "admin/getRates",
			blockTime: "settime/blockUse",
			returnLineChartData: "influx/getLineChartData",
			getPeriodConsumption: "influx/getPeriodConsumption",
			setMapDay: 'settime/setMapDay',
			getGroupCircuits: "admin/getGroupCircuits",
		}),
		changeTooltipUnit() {
			if (!this.viewUnit) {
				this.lineOption.tooltip.formatter = function (params) {
					let unit = "Wh";
					let dDate = params.value[0].slice(0, 10);
					let dHour = params.value[0].slice(11, 16);
					let d = dDate + ' ' + dHour;
					if (params.seriesName.includes("Frequency")) unit = "Hz";
					if (params.seriesName.includes("Voltage")) unit = "V";
					return `${params.seriesName} <br/> ${d} <br/> ${params.value[1]} ${unit}`;
				}
				this.pieOption.tooltip.formatter = "{b}, {c} Wh";
				this.option.yAxis[0].axisLabel.formatter = "{value} Wh";
			} else {
				this.lineOption.tooltip.formatter = function (params) {
					let unit = "W";
					let dDate = params.value[0].slice(0, 10);
					let dHour = params.value[0].slice(11, 16);
					let d = dDate + ' ' + dHour;
					if (params.seriesName.includes("Frequency")) unit = "Hz";
					if (params.seriesName.includes("Voltage")) unit = "V";
					return `${params.seriesName} <br/> ${d} <br/> ${params.value[1]} ${unit}`;
				}
				this.pieOption.tooltip.formatter = "{b}, {c} W";
				this.option.yAxis[0].axisLabel.formatter = "{value} W";
			}
		},
		makeSelectedDayRange(data) {
			let start = new Date(data);
			start.setDate(start.getDate() + 1);
			let end = start.toISOString().slice(0,10) + 'T00:00:00Z';
			return [data, end, 'hour'];
		},
		getDays(date_1, date_2)  {
			let difference = date_1.getTime() - date_2.getTime();
			let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
			return Math.abs(TotalDays);
		},
		changeViewUnit() {
			this.changeUnit = true;
		},
		changeSPHRate(time) {
			const rangeDays = this.getDays(new Date(time[0]), new Date(time[1]));
			if (rangeDays > 90) {
				this.sph = 1;
			}

			if (rangeDays < 91 && rangeDays > 30) {
				this.sph = 1.5;
			}

			if (rangeDays < 31 && rangeDays > 10) {
				this.sph = 3;
			}

			if (rangeDays < 11 && rangeDays > 2 ) {
				this.sph = 6;
			}

			if (rangeDays < 3) {
				this.sph = 60;
			}
		},
		changeXAxisLabel(time) {
			if (typeof time === 'object') {
				let _date = new Date(time.start);
				let start = _date.toISOString().slice(0, 10) + 'T00:00:00Z';
				_date = new Date(time.end);
				_date.setDate(_date.getDate() + 1);
				let end = _date.toISOString().slice(0, 10) + 'T00:00:00Z';
				const rangeDays = this.getDays(new Date(start), new Date(end));

				if (rangeDays < 3) {
					this.lineOption.xAxis.axisLabel.formatter = function(d) {
						return moment(d).format('HH:mm');
					}
				}

				if (rangeDays > 2 && rangeDays < 32) {
					this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
						const d = new Date(value);
						const options = {
							month: '2-digit', 
							day: '2-digit',
							hour: '2-digit', 
							minute: '2-digit',
							hour12: false ,
							timeZone: "Africa/Dakar"
						};
						return d.toLocaleString('en-US', options).replace(',', '');
					}
				}

				if (rangeDays > 32) {
					this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
						const d = new Date(value);
						const options = {
							month: '2-digit', 
							day: '2-digit',
							hour: '2-digit', 
							minute: '2-digit',
							hour12: false ,
							timeZone: "Africa/Dakar"
						};
						return d.toLocaleString('en-US', options).replace(',', '');
					}
				}
				
			} else {
				switch (time) {
					case 'last':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('HH:mm');
						}
						break;
					case '6hours':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('HH:mm');
						}
						break;
					case 'day':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('HH:mm');
						}
						break;
					case '2days':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('HH:mm');
						}
						break;
					case 'week':
						this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
							const d = new Date(value);
							const options = {
								month: '2-digit', 
								day: '2-digit',
								hour: '2-digit', 
								minute: '2-digit',
								hour12: false ,
								timeZone: "Africa/Dakar"
							};
							return d.toLocaleString('en-US', options).replace(',', '');
						}	
						break;
					case 'month':
						this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
							const d = new Date(value);
							const options = {
								month: '2-digit', 
								day: '2-digit',
								hour: '2-digit', 
								minute: '2-digit',
								hour12: false ,
								timeZone: "Africa/Dakar"
							};
							return d.toLocaleString('en-US', options).replace(',', '');
						}	
						break;
					case 'year':
						this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
							const d = new Date(value);
							const options = {
								month: '2-digit', 
								day: '2-digit',
								hour: '2-digit', 
								minute: '2-digit',
								hour12: false ,
								timeZone: "Africa/Dakar"
							};
							return d.toLocaleString('en-US', options).replace(',', '');
						}	
						break;
					case 'pMonth':
						this.lineOption.xAxis.axisLabel.formatter = function (value, index) {
							const d = new Date(value);
							const options = {
								month: '2-digit', 
								day: '2-digit',
								hour: '2-digit', 
								minute: '2-digit',
								hour12: false ,
								timeZone: "Africa/Dakar"
							};
							return d.toLocaleString('en-US', options).replace(',', '');
						}	
						break;
					case 'pYear':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('MM');
						}
						break;
					case 'today':
						this.lineOption.xAxis.axisLabel.formatter = function(d) {
							return moment(d).format('HH:mm');
						}
				}
			}
		},
		async getTariff(site) {
			const rates = await this.getRates(site);
			this.tariff = {
				day: rates[rates.length - 1].cost_1,
				night: rates[rates.length - 1].cost_2,
				gen: rates[rates.length - 1].cost_3
			}
		},
		selectSeriesAll() {
			this.isLineLoading = true;
			if (this.showAll) {
				this.lineOption.series.forEach(item =>  {
					this.$refs.lineChart.dispatchAction({type: 'legendUnSelect', name: item.name});
				});
			} else {
				this.lineOption.series.forEach(item =>  {
					this.$refs.lineChart.dispatchAction({type: 'legendSelect', name: item.name});
				});
			}
			this.isLineLoading = false;
		},
		onCheck(val) {
			if (val.length == 0) {
				this.lineChartFields.forEach((item) => (item.useDevice = false));
			} else {
				this.lineChartFields.forEach((item) => {
					let field = val.find((p) => p === item.field);
					if (field) {
						item.useDevice = true;
					} else {
						item.useDevice = false;
					}
				});
			}
			this.changeCustomSectionSetting = true;
		},
		getValueTime(value) {
			if (value.start !== null) {
				return value.start + "-" + value.end;
			} else {
				return "";
			}
		},
		makeCurrentWholeTimePower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth(), 2);
			let lastDay = date.setDate(date.getDate() + 1);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makePrevWholeTimePower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 2);
			let lastDay = new Date(date.getFullYear(), date.getMonth(), 1);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makeCurrentWholeYearPower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), 0, 2);
			let lastDay = new Date(date.getFullYear(), 11, 2);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setMonth(d.getMonth() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makePrevWholeYearPower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear() - 1, 0, 2);
			let lastDay = new Date(date.getFullYear() - 1, 11, 2);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setMonth(d.getMonth() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		getUnitString() {
			return 'KWh';
		},
		async getRealTimeData() {
			this.isLoading = true;
			if (this.option.series[0].hasOwnProperty('stack')) {
				delete this.option.series[0].stack;
				delete this.option.series[1].stack;
			}
			let currentDayPower = [],
				currentNightPower = [],
				prevDayPower = [],
				prevNightPower = [],
				predictWeekDayPower = [],
				predictWeekNightPower = [],
				currentWeekDayPower = [],
				currentWeekNightPower = [],
				predictDayPower = [],
				predictNightPower = [],
				currentPower = [],
				predictPower = [],
				prevPower = [];
			let currentTotal = 0,
				predictTotal = 0;

			if (this.isReturnLineChartData) {
				if (this.fieldName == "overall") {
					await this.getDisplayData("overall");
				} else {
					const powerData = await this.getDisplayData(this.fieldName);
					this.powerData = powerData;
				}
			}

			if (this.fieldName == "overall") {
				currentDayPower = this.currentDayPower;
				currentNightPower = this.currentNightPower;
				predictDayPower = this.predictDayPower;
				predictNightPower = this.predictNightPower;
				prevDayPower = this.prevDayPower;
				prevNightPower = this.prevNightPower;
			} else {
				currentDayPower = this.powerData[0];
				currentNightPower = this.powerData[1];
				prevDayPower = this.powerData[2];
				prevNightPower = this.powerData[3];
				predictDayPower = this.powerData[6];
				predictNightPower = this.powerData[7];
			}

			if (this.periodTime == "today") {
				currentPower = currentNightPower.concat(currentDayPower);
				predictPower = predictNightPower.concat(predictDayPower);
			} 
			if (this.periodTime == "month") {
				currentDayPower = this.makeCurrentWholeTimePower(currentDayPower);
				currentNightPower = this.makeCurrentWholeTimePower(currentNightPower);

				prevDayPower = this.makePrevWholeTimePower(prevDayPower);
				prevNightPower = this.makePrevWholeTimePower(prevNightPower);
			
				currentNightPower.forEach((item, index) => {
					let value = !!currentDayPower[index]? item[1] + currentDayPower[index][1]: item[1];
					currentPower.push([item[0], value]);
				});

				if (predictDayPower.length >= predictNightPower.length) {
					predictDayPower.forEach((item, index) => {
						if (!!predictNightPower[index] && predictNightPower[index][0] === item[0]) {
							predictPower.push([
								item[0],
								predictNightPower[index][1] + item[1]
							]);
						} else {
							predictPower.push([
								item[0],
								item[1]
							]);
						}
					});
				}

				if (predictDayPower.length < predictNightPower.length) {
					predictNightPower.forEach((item, index) => {
						if (!!predictDayPower[index] && predictDayPower[index][0] === item[0]) {
							predictPower.push([
								item[0],
								predictDayPower[index][1] + item[1]
							]);
						} else {
							predictPower.push([
								item[0],
								item[1]
							]);
						}
					});
				}
			}

			if (this.periodTime == "year") {
				currentDayPower = this.makeCurrentWholeYearPower(currentDayPower);
				currentNightPower = this.makeCurrentWholeYearPower(currentNightPower);
				prevDayPower = this.makePrevWholeYearPower(prevDayPower);
				prevNightPower = this.makePrevWholeYearPower(prevNightPower);

				currentNightPower.forEach((item, index) => {
					let value = !!currentDayPower[index]? item[1] + currentDayPower[index][1]: item[1];
					currentPower.push([item[0], value]);
				});
				
				if (predictDayPower.length >= predictNightPower.length) {
					predictDayPower.forEach((item, index) => {
						if (!!predictNightPower[index] && predictNightPower[index][0] === item[0]) {
							predictPower.push([
								item[0],
								predictNightPower[index][1] + item[1]
							]);
						} else {
							predictPower.push([
								item[0],
								item[1]
							]);
						}
					});
				}

				if (predictDayPower.length < predictNightPower.length) {
					predictNightPower.forEach((item, index) => {
						if (!!predictDayPower[index] && predictDayPower[index][0] === item[0]) {
							predictPower.push([
								item[0],
								predictDayPower[index][1] + item[1]
							]);
						} else {
							predictPower.push([
								item[0],
								item[1]
							]);
						}
					});
				}
			}
			currentPower.forEach((item) => (currentTotal += item[1]));
			predictPower.forEach((item) => (predictTotal += item[1]));

			this.currentTotal = currentTotal.toFixed(2);
			this.predictTotal = (currentTotal + predictTotal).toFixed(2);

			this.currentDayDisplayData = currentDayPower;
			this.currentNightDisplayData = currentNightPower;
			this.previousDayDisplayData = prevDayPower;
			this.previousNightDisplayData = prevNightPower;

			if (this.activeIndex == "current") {
				this.switchCurrentPreviousData(
					this.currentDayDisplayData,
					this.currentNightDisplayData
				);
			} else {
				this.switchCurrentPreviousData(
					this.previousDayDisplayData,
					this.previousNightDisplayData
				);
			}
		},
		switchCurrentPreviousData(day, night) {
			let dayTotal = 0;
			let nightTotal = 0;
			let _day = day;
			let _night = night;

			_day.forEach((item, index) => {
				dayTotal += item[1];
			});

			_night.forEach((item, index) => {
				nightTotal += item[1];
			});

			if (!this.viewUnit) {
				day.forEach((item, index) => {
					_day[index] = [item[0], item[1]];
				});

				night.forEach((item, index) => {
					_night[index] = [item[0], item[1]];
				});
			} else {
				day.forEach((item, index) => {
					_day[index] = [item[0], item[1] * this.sph];
				});

				night.forEach((item, index) => {
					_night[index] = [item[0], item[1] * this.sph];
				});
			}
			let total = dayTotal + nightTotal;

			this.totalPower = total.toFixed(2);
			this.dayTotalPower = dayTotal.toFixed(2);
			this.nightTotalPower = nightTotal.toFixed(2);

			if (this.periodTime !== 'today') {
				this.option.series[0].stack = 'realtime';
				this.option.series[1].stack = 'realtime';
			}

			let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site
			this.option.series[0].data = _day;
			this.option.series[1].data = _night;
			this.isLoading = false;
		},
		changeTitle(value) {
			let label = this.usages.find((i) => i.value === this.fieldName);
			switch (value) {
				case "today":
					this.currentTitle = "today";
					this.previousTitle = "yesterday";

					if (this.activeIndex === "current") {
						this.ctTitle = "so far today " + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + " " + label.label;
					}
					break;
				case "month":
					this.currentTitle = "this month";
					this.previousTitle = "last month";
					if (this.activeIndex === "current") {
						this.ctTitle = "so far this month " + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + " " + label.label;
					}
					break;
				case "year":
					this.currentTitle = "this year";
					this.previousTitle = "last year";
					if (this.activeIndex === "current") {
						this.ctTitle = "so far this year " + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + " " + label.label;
					}
					break;
			}
		},
		setActive(index) {
			this.activeIndex = index;
			let dayName = `${index}DayDisplayData`;
			let nightName = `${index}NightDisplayData`;
			this.changeTitle(this.periodTime);
			this.switchCurrentPreviousData(this[dayName], this[nightName]);
		},
		async selectField(event) {
			this.fieldName = event.target.value;
			this.previousDayDisplayData = [];
			this.currentNightDisplayData = [];
			this.previousNightDisplayData = [];
			this.currentDayDisplayData = [];
			await this.getRealTimeData();
			this.changeTitle(this.periodTime);
		},
		async changeView(e) {
			await this.getTariff(this.user.siteId);
			this.runDisplay();
			if (this.currentDayDisplayData.length === 0) {
				this.changeTitle(this.periodTime);
				await this.getRealTimeData(this.periodTime);
			}
			this.showResult();
		},
		selectPeriodTime(e) {
			this.timePeriod = e.target.value;
			this.changeCustomSectionSetting = true;
			this.specialTimePeriod = true;
		},
		onDateRangeChange() {
			let start = this.pickedDateRange.start;
			let end = this.pickedDateRange.end;
		},
		showResult() {
			this.isLineLoading = true;
			this.lineOption.yAxis = [];
			this.lineOption.series = [];
			this.lineOption.legend.data = [];
			this.pieOption.series[0].data = [];
			this.getLineChartData();
			this.runDisplay();
			this.blockTime(true);
			this.pickedDateRange = null;
			this.lineChartFields.forEach((item) => {
				if (!item.useDevice && item.type !== 'Voltage' && item.type !== 'Frequency') {
					this.consumptionName = 'Selected Consumption';
				}
			});
		},
		getTitleTimeRange(start, end) {
			let date = new Date(start);
			let displayDate = date.getDate();
			let displayMonth = this.monthNames[date.getMonth()]
			let started = `00:00 ${displayDate} ${displayMonth}`;

			let enddate = new Date(end);
			let endMonth = this.monthNames[enddate.getMonth()];
			let endDate = enddate.getDate();
			let endtext = `00:00 ${endDate} ${endMonth}`;

			return [started, endtext];
		},
		runDisplay() {
			let powerDevices = this.lineChartFields.filter(
				(item) =>
					!!item.useDevice &&
					!item.label.includes("Voltage") &&
					!item.label.includes("Frequency") &&
					item.type != 'Group'
			);
			let devices = [];
			powerDevices.map(item => devices.push(item.field));

			let unselectedDevices = this.lineChartFields.filter(i => !i.useDevice && i.type !== 'Voltage' && i.type !== 'Frequency');
			if (unselectedDevices.length > 0) {
				this.getDisplayWeekData(devices);
			} else {
				this.getDisplayWeekData(['overall']);
			}
		},
		sliceIntoChunks(arr, chunkSize) {
			const res = [];
			for (let i = 0; i < arr.length; i += chunkSize) {
				const chunk = arr.slice(i, i + chunkSize);
				res.push(chunk);
			}
			return res;
		},
		isReturnLineChartData() {
			if (this.changePeriod) return true;
			if (this.changeCustomSectionSetting && !this.changeUnit) return true;
			if (this.firstLoading) return true;
			return false;
		},
		async getLineChartData() {
			let time = '';
			let range = '';
			let overallDevices = [];
			let solarDevices = [];

			if (this.selectedMapDay != '') {
				range = this.makeSelectedDayRange(this.selectedMapDay);
				this.changeXAxisLabel(this.periodTime);
			} else {
				if (!this.specialTimePeriod) {
					if (this.periodTime == 'month') time ='pMonth';
					if (this.periodTime == 'year') time ='pYear';
					if (this.periodTime == 'today') time ='today';
				} else {
					time = !!this.pickedDateRange
					? this.pickedDateRange
					: this.timePeriod;
				}
				this.changeXAxisLabel(time);
				range = this.getSelectedTimeRange(time);

			}
			let query = "";
			let powerDevice = this.lineChartFields.filter(
				(item) =>
					!!item.useDevice &&
					!item.label.includes("Voltage") &&
					!item.label.includes("Frequency") &&
					item.type != 'Group'
			);
			let voltageDevice = this.lineChartFields.filter(
				(item) => !!item.useDevice && item.label.includes("Voltage")
			);
			let frequencyDevice = this.lineChartFields.filter(
				(item) => !!item.useDevice && item.label.includes("Frequency")
			);
			let devices = [];

			if (
				powerDevice.length === 0 &&
				voltageDevice.length === 0 &&
				frequencyDevice.length === 0
			) {
				this.$toasted.show("Please select one device at least", {
					type: "error",
					closeOnSwipe: true,
					fitToScreen: true,
					duration: 2500,
					theme: "bubble",
				});
				return;
			}

			if (voltageDevice.length > 0) {
				this.lineOption.yAxis.push({
					type: "value",
					name: "V",
					nameRotate: 90,
					nameGap: 40,
					nameLocation: "middle",
					splitNumber: 4,
					nameTextStyle: {
						color: "#FDFDFD",
						fontSize: 14,
					},
					splitLine: {
						show: false,
					},
					axisLabel: {
						color: "#FDFDFD",
						formatter: "{value}V",
					},
				});
				for (let i = 0; i < voltageDevice.length; i++) {
					query += voltageDevice[i].field + ", ";
					devices.push(voltageDevice[i].field);
				}
			}
			//
			if (frequencyDevice.length > 0) {
				let offset = this.lineOption.yAxis.length === 1 ? 65 : 0;
				this.lineOption.yAxis.push({
					type: "value",
					name: "Hz",
					nameRotate: 90,
					nameLocation: "middle",
					nameGap: 40,
					nameTextStyle: {
						color: "#FDFDFD",
						fontSize: 14,
					},
					offset: offset,
					position: "left",
					splitLine: {
						show: false,
					},
					axisLabel: {
						color: "#FDFDFD",
						formatter: "{value}Hz",
					},
				});

				for (let i = 0; i < frequencyDevice.length; i++) {
					query += frequencyDevice[i].field + ", ";
					devices.push(frequencyDevice[i].field);
				}
			}
			//
			if (powerDevice.length > 0) {
				let offset = 0;
				if (this.lineOption.yAxis.length == 1) {
					offset = 75;
				}
				if (this.lineOption.yAxis.length == 2) {
					offset = 130;
				}

				if (!this.viewUnit) {
					this.lineOption.yAxis.push({
						type: "value",
						name: "Wh",
						nameRotate: 90,
						nameLocation: "middle",
						nameGap: 45,
						nameTextStyle: {
							color: "#FDFDFD",
							fontSize: 14,
						},
						offset: offset,
						position: "left",
						splitLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
								type: "dashed",
								width: 1,
							},
						},
						axisLabel: {
							color: "#FDFDFD",
							formatter: "{value}Wh",
						},
					});
				} else {
					this.lineOption.yAxis.push({
						type: "value",
						name: "W",
						nameRotate: 90,
						nameLocation: "middle",
						nameGap: 45,
						nameTextStyle: {
							color: "#FDFDFD",
							fontSize: 14,
						},
						offset: offset,
						position: "left",
						splitLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
								type: "dashed",
								width: 1,
							},
						},
						axisLabel: {
							color: "#FDFDFD",
							formatter: "{value} W",
						},
					});
				}
				
				for (let i = 0; i < powerDevice.length; i++) {
					query += powerDevice[i].field + ", ";
					devices.push(powerDevice[i].field);
				}
			}

			if (this.lineOption.yAxis.length === 1) this.lineOption.grid.left = "8%";
			if (this.lineOption.yAxis.length === 2) this.lineOption.grid.left = "14%";
			if (this.lineOption.yAxis.length === 3) this.lineOption.grid.left = "20%";

			query = query.substring(0, query.length - 2);
			let date = new Date();
			let _range = [];
			let unselectedDevices = this.lineChartFields.filter(i => !i.useDevice && i.type !== 'Voltage' && i.type !== 'Frequency');
			if (unselectedDevices.length == 0) {
				switch(this.periodTime) {
					case 'today':
						_range = range;
						break;
					case 'month':
						let firstDay = new Date(date.getFullYear(), date.getMonth(), 2);
						let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
						firstDay = firstDay.toISOString().slice(0, 10) + 'T00:00:00Z';
						lastDay = lastDay.toISOString().slice(0, 10) + 'T23:59:59Z';
						_range = [firstDay, lastDay];
						break;
					case 'year':
						let year = date.getFullYear();
						let start = year + '-01-01T00:00:00Z';
						let end = year + '-12-31T23:59:59Z';
						_range = [start, end];
						break;
				}
			} else {
				_range = range;
			}

			if (unselectedDevices.length === 0) {
				let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site;
				switch(site) {
					case 'Somewhere Else 2':
						overallDevices = [
							'device_14', 'device_15', 'device_16', 'device_17', 
							'device_18', 'device_19', 'device_25', 'device_28', 
							'device_29', 'device_30', 'device_31', 'device_32',
							'device_33', 'device_34', 'device_35', 'device_36',
							'device_37', 'device_38', 'device_40', 'device_41',
							'device_42', 'device_43', 'device_44', 'device_45',
							'device_46', 'device_47', 'device_48', 'device_49',
							'device_50', 'device_51', 'device_53', 'device_54',
							'device_55'
						];
						break;
					case 'Brook Green':
						overallDevices = ['device_27', 'device_28', 'device_29'];
						break;
					case 'Brook Green Updated':
						overallDevices = ['device_56', 'device_57', 'device_58'];
						break;
					case 'Richard Brown':
						overallDevices = [
							'device_11', 'device_12', 'device_13',
							'device_14', 'device_15', 'device_16',
							'device_17', 'device_18', 'device_19',
							'device_20', 'device_21', 'device_22',
							'device_23', 'device_24', 'device_25',
						];
						break;
					default:
						overallDevices = [];
						this.user.devices.forEach(device => {
							if (device.overall == '1' && device.device_type !== 'Electricity Gen (Wh)') {
								let device_name = 'device_' + device.device_order;
								overallDevices.push(device_name);
							}

							if (device.device_type == 'Electricity Gen (Wh)') {
								let device_name = 'device_' + device.device_order;
								solarDevices.push(device_name);
							}
						});

						if (overallDevices.length == 0) {
							this.$toasted.show("Please select one overall circuit at least", {
								type: "error",
								closeOnSwipe: true,
								fitToScreen: true,
								duration: 2500,
								theme: "bubble",
							});
						}
						break;
				}

				let vm = this;

				if (this.isReturnLineChartData() ) {
					vm.getPeriodConsumption({
						range: _range,
						devices: overallDevices,
					}).then(res => {
						vm.consumption =
							res && res.length > 0
								? Math.round((res[0] + Number.EPSILON) * 100) / 100
								: 0;
						vm.consumptionLoading = false;
						vm.consumptionData = res;
					});
				} else {
					this.consumption =
							this.consumptionData && this.consumptionData.length > 0
								? Math.round((this.consumptionData[0] + Number.EPSILON) * 100) / 100
								: 0;
					this.consumptionLoading = false;
				}

			} else {
				let selectedDevices = this.lineChartFields.filter(i => i.useDevice && i.type !== 'Voltage' && i.type !== 'Frequency');
				let checkedDevices = [];
				selectedDevices.forEach(item => {
					checkedDevices.push(item.field);
				});

				let vm = this;
				if (this.isReturnLineChartData() ) {
					vm.getPeriodConsumption({
						range: _range,
						devices: checkedDevices,
					}).then(res => {
						vm.consumption =
							res && res.length > 0
								? Math.round((res[0] + Number.EPSILON) * 100) / 100
								: 0;
						vm.consumptionLoading = false;
						vm.consumptionData = res;
					});
				} else {
					this.consumption =
							this.consumptionData && this.consumptionData.length > 0
								? Math.round((this.consumptionData[0] + Number.EPSILON) * 100) / 100
								: 0;
					this.consumptionLoading = false;
				}
			}

			if (this.isReturnLineChartData() ) {
				let queryString = query;
				let devicesArray = queryString.split(',');
				devicesArray = devicesArray.filter(device => {
					device = device.trim(); // Trim whitespace from the current element
					return device !== "consumed" && device !== "exported";
				});

				queryString = devicesArray.join(', ');
				const data = await this.returnLineChartData({
					range: range,
					query: queryString,
				});

				this.changeSPHRate(range);
				this.lineChartData = data;
				this.firstLoading = false;
				this.changePeriod = false;
			}

			//this.CSVData
			this.devices = devices;
			this.lineChartData = this.createConsumedAndExportedData(this.lineChartData, overallDevices, solarDevices);
			this.lineChartData = this.createGroupData(this.lineChartData);
			this.CSVData = this.lineChartData;

			let _data = [];

			if (this.lineChartData.length > 0) {
				if (this.periodTime == 'today' && this.selectedMapDay === '' && !this.specialTimePeriod) 
				{
					_data = this.getFullDayHourData(this.lineChartData);
				} else {
					this.setMapDay('');
					_data = this.lineChartData;
				}
			}

			let timeString = this.getTitleTimeRange(range[0], range[1]);
			let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site;
			this.lineOption.title.text = `${site} - ${timeString[0]} to ${timeString[1]}`;
			let chartData = [];

			for (let i = 0; i < _data.length; i++) {
				if (!this.viewUnit) {
					this.devices.forEach((item) => {
						if (Object.keys(chartData).includes(item)) {
							chartData[item].push([
								_data[i]["date_formatted"],
								parseFloat(_data[i][item]),
							]);
						} else {
							chartData[item] = [
								[
									_data[i]["date_formatted"], 
									parseFloat(_data[i][item])
								],
							];
						}
					});
				} else {
					this.devices.forEach((item) => {
						if (Object.keys(chartData).includes(item)) {
							let type = this.lineChartFields.find(it => it.field == item);
							
							if (type.type != "Voltage" && type.type != "Frequency") {
								chartData[item].push([
									_data[i]["date_formatted"],
									parseFloat(_data[i][item]) * this.sph,
								]);
							} else {
								chartData[item].push([
									_data[i]["date_formatted"],
									parseFloat(_data[i][item]),
								]);
							}
							
						} else {
							let type = this.lineChartFields.find(it => it.field == item);
							
							if (type.type != "Voltage" && type.type != "Frequency") {
								chartData[item] = [
									[
										_data[i]["date_formatted"], 
										parseFloat(_data[i][item]) * this.sph
									],
								];
							} else {
								chartData[item] = [
									[
										_data[i]["date_formatted"], 
										parseFloat(_data[i][item])
									],
								];
							}
							
						}
					});
				}
			}

			let powerDevices = [];
			this.devices.map((item) => {
				let deviceItem = this.lineChartFields.find((i) => i.field === item);
				if (deviceItem) {
					let label = deviceItem.label;
					if (
						!label.includes("Frequency") &&
						!label.includes("Voltage") &&
						deviceItem.type != 'Group'
					) {
						powerDevices.push(item);
					}
				}
			});
		
			let seriesData = [];
			let keys = Object.keys(chartData);

			for (let i = 0; i < keys.length; i++) {
				let field = this.lineChartFields.find((item) => item.field === keys[i]);
				let label = field.label;

				if (label.includes("Frequency")) {
					let f = this.lineOption.yAxis.findIndex((item) => item.name === "Hz");
					this.lineOption.series.push({
						name: label,
						data: chartData[keys[i]],
						symbolSize: 0.1,
						yAxisIndex: f,
						type: "line",
					});
					seriesData.push(label);
				} else if (label.includes("Voltage")) {
					let v = this.lineOption.yAxis.findIndex((item) => item.name === "V");
					this.lineOption.series.push({
						name: label,
						data: chartData[keys[i]],
						symbolSize: 0.1,
						yAxisIndex: v,
						type: "line",
					});
					seriesData.push(label);
				} else {
					let w = null;
					if (!this.viewUnit) {
						w = this.lineOption.yAxis.findIndex((item) => item.name === "Wh");
					} else {
						w = this.lineOption.yAxis.findIndex((item) => item.name === "W");
					}

					let keyName = keys[i];
					let item = this.lineChartFields.find(item => item['field'] === keyName);
					let name = item['label'];

					let value = this.getTotalConsumption(chartData[keys[i]]);
					this.pieOption.series[0].data.push({
						name: name,
						value: Math.round((value + Number.EPSILON) * 100) / 100
					});

					this.lineOption.series.push({
						name: label,
						data: chartData[keys[i]],
						symbolSize: 0.1,
						yAxisIndex: w,
						type: "line",
					});
					seriesData.push(label);
				}
			}
			this.isLineLoading = false;
			this.lineOption.legend.data = seriesData;
		},
		createConsumedAndExportedData(lineChartData, overallDevices, solarDevices){
			if (solarDevices.length == 0) return lineChartData;
			for (let i = 0; i < lineChartData.length; i++) {
				let sumOverallConsumption = 0;
				let sumSolarConsumption = 0;

				let keys = Object.keys(lineChartData[i]);
				keys.map(key => {
					if (solarDevices.includes(key) && key != 'date_formatted') {
						sumSolarConsumption += parseFloat(lineChartData[i][key]);
					} 
					if (overallDevices.includes(key) && key != 'date_formatted') {
						sumOverallConsumption += parseFloat(lineChartData[i][key]);
					}
				});

				if (sumOverallConsumption - sumSolarConsumption > 0) {
					let item = this.lineChartFields.find(lc => lc.field == "consumed");
					if (!item) {
						this.lineChartFields.push({
							useDevice: true, 
							field: "consumed", 
							label: "Consumed",
							type: "calculation"
						});
						this.devices.push("consumed");
					}
					lineChartData[i]['consumed'] = Math.round((sumOverallConsumption - sumSolarConsumption + Number.EPSILON) * 100000) / 100000;
					
				} else {
					let item = this.lineChartFields.find(lc => lc.field == "exported");
					if (!item) {
						this.lineChartFields.push({
							useDevice: true, 
							field: "exported", 
							label: "Exported",
							type: "calculation"
						});
						this.devices.push("exported");
					}
					lineChartData[i]['exported'] = Math.round((sumSolarConsumption - sumOverallConsumption + Number.EPSILON) * 100000) / 100000;
				}
			}
			return  lineChartData;
		},

		createGroupData(linedata) {
			if (this.groupCircuits.length == 0) return linedata;

			for (let i = 0; i < linedata.length; i++) {
				this.groupCircuits.forEach(group => {
					let checkOptionItem = this.lineChartFields.find(i => i['label'] == group['name']);
					if (checkOptionItem && !!checkOptionItem['useDevice']) {
						let deviceOrders = JSON.parse(group['devices']);
						let addValue = 0;
						let newKey = group['devices'];

						deviceOrders.map(order => {
							let key = 'device_' + order;
							addValue += parseFloat(linedata[i][key]);
						});
						linedata[i][newKey] = Math.round((addValue + Number.EPSILON) * 100000) / 100000;
						let device = this.devices.find(d => d == newKey);
						if (!device) this.devices.push(newKey);
					}
				});
			}
			return linedata;
		},
		getFullDayHourData(data) {
			const d = new Date();
			let hr = d.getHours();
			let _minute = d.getMinutes();
			let _fullData = [];

			for (let hour = hr; hour < 24; hour++) {
				let hourString = ''; let minuteString = '';

				if (hour < 10) hourString = '0' + hour.toString();
				else  hourString = hour.toString();
				
				let timeString = '';
				
				if (hour == hr) {
					for (let minute = _minute + 1; minute < 60; minute++) {
						if (minute < 10) minuteString = '0' + minute.toString();
						else  minuteString = minute.toString();
						timeString = d.toISOString().slice(0, 10) + 'T' + hourString + ":" + minuteString + ':00Z';

						let newItem = {};

						Object.keys(data[0]).forEach(item => {
							if (item == 'date_formatted') {
								Object.assign(newItem, {'date_formatted': timeString})
							} else {
								Object.assign(newItem, {[item]: null});
							}
						});

						_fullData.push(newItem);
					}
				} else {
					for (let minute = 0; minute < 60; minute++) {
						if (minute < 10) minuteString = '0' + minute.toString();
						else  minuteString = minute.toString();
						timeString = d.toISOString().slice(0, 10) + 'T' + hourString + ":" + minuteString + ':00Z';
						let newItem = {};

						Object.keys(data[0]).forEach(item => {
							if (item == 'date_formatted') {
								Object.assign(newItem, {'date_formatted': timeString})
							} else {
								Object.assign(newItem, {[item]: null});
							}
						});
						_fullData.push(newItem);
					}
				}
			}

			return [...data, ..._fullData];
		},
		getTotalConsumption(arr) {
			let total = 0;
			arr.forEach(item => {
				if (!Number.isNaN(item[1])) total += item[1];
			});

			return total;
		},
		getCSVData() {
			let csvJsonData = [];

			for (let i = 0; i < this.CSVData.length; i++) {
				let csvObject = {};
				let date = new Date(this.CSVData[i][0]);
				let hour = date.getHours();
				
				let timeKey = "Local Time";
				let timeValue = this.getTimeValue(this.CSVData[i]["date_formatted"]);
				Object.assign(csvObject, { [timeKey]: timeValue });

				let key, value;
				let frequencySeries = ["Frequency 1", "Frequency 2", "Frequency 3", "Frequency"];
				let voltageSeries = ["Voltage 1", "Voltage 2", "Voltage 3"];

				this.devices.forEach((item, index) => {
					let field = this.lineChartFields.find((i) => i.field === item);

					if (field.label.includes("Frequency")) {
						key = field.label + " (Hz)";
						value = this.CSVData[i][item];
						Object.assign(csvObject, { [key]: value });
					} else if (field.label.includes("Voltage")) {
						key = field.label + " (V)";
						value = this.CSVData[i][item];
						Object.assign(csvObject, { [key]: value });
					} else {
						key = field.label + " (Wh)";
						value = this.CSVData[i][item];
						Object.assign(csvObject, { [key]: value });
					}
				});
				csvJsonData.push(csvObject);
			}

			return csvJsonData;
		},
		getTimeValue(time) {
			let result = time;
			return result.slice(0, 10) + " " + result.slice(11, 16);
		},
		getCSVfile(data) {
			const replacer = (key, value) => (value === null ? "" : value);
			const header = Object.keys(data[0]);
			let csv = data.map((row) =>
				header
					.map((fieldName) => JSON.stringify(row[fieldName], replacer))
					.join(",")
			);
			csv.unshift(header.join(","));
			let csvArray = csv.join("\r\n");

			var blob = new Blob([csvArray], { type: "text/csv" });
			let todayString = new Date().toISOString().slice(0, 10);
			let name = "knowatts.co.uk_download_" + todayString;
			saveAs(blob, `${name}.csv`);
		},
		downloadCSV() {
			let data = this.getCSVData();
			this.getCSVfile(data);
		},
		async getDisplayWeekData(devices) {
			if (this.isReturnLineChartData()) {
				const weekPower = await this.getWeekData(devices);
				this.weekPower = weekPower
			}
			const sofarWeek = this.weekPower[0];
			const predictWeek = this.weekPower[1];
			let sofarWeekTotal = 0,
				predictWeekTotal = 0;
			sofarWeek.forEach((d) => (sofarWeekTotal += d[1]));
			predictWeek.forEach((d) => (predictWeekTotal += d[1]));
			this.currentWeekTotal = Math.round((sofarWeekTotal + Number.EPSILON) * 100) / 100;
			this.predictWeekTotal = Math.round((sofarWeekTotal + predictWeekTotal + Number.EPSILON) * 100) / 100;
		},
		selectSpecialPeriod() {
			this.blockTime(false);
			this.changeCustomSectionSetting = true;
			this.specialTimePeriod = true;
		},
	},
};
</script>
<style lang="scss" scoped>
.line-chart {
	height: 1050px;
}
.chart {
	height: 450px;
}
.pie-chart {
	height: 250px;
}
#a2,
#a1 {
	color: rgb(253, 253, 253);
	opacity: 0.5;
	text-transform: uppercase;
	cursor: pointer;
}

#a1:before,
#a2:before {
	transition: border-bottom 0.3s ease;
}

.active {
	opacity: 1 !important;
	border-bottom: 2px solid rgb(253, 253, 253);
}

#appliance-select,
#period-select {
	width: 180px;
	height: 30px;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 4px;
}

#usage-power-info {
	max-width: 200px;
	margin: 0 auto;
}

.period-text {
	width: 160px;
	height: 30px;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-radius: 4px;
	border: 1px solid #fdfdfd;
	margin-bottom: 30px;
}

.filter-action {
	width: 200px;
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.display-time {
	width: 160px;
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	color: white;
}

.timepickerbutton {
	height: 30px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.loading {
	top: 100% !important;
	left: 47% !important;
	padding: 10px;
}

.kpi-title {
	font-size: 16px !important;
	text-transform: uppercase;
	color: #fdfdfd;
	opacity: 0.8;
	font-family: "Nunito Sans Light";
	font-weight: 100;
}

.kpi-content,
.t-head {
	font-size: 32px;
	color: #fdfdfd;
	font-family: "Nunito Sans Semi-bold";
}

.t-head {
	text-align: center;
	margin-bottom: 5px;
	padding-bottom: 5px;
	font-size: 32px;
	color: #fdfdfd;
	font-family: "Nunito Sans Semi-bold";
}
.t-title {
	font-size: 16px;
	font-family: "Nunito Sans Light";
	text-align: left;
	margin-right: 0;
	margin-top: 0;
	margin-bottom: 0;
	color: hsla(0, 0%, 99%, 0.7);
	width: 100%;
	padding: 0 15px;

	.t-content {
		font-size: 16px;
		color: #fdfdfd;
		font-family: "Nunito Sans Regular" !important;
		float: right;
		margin-left: -10px;
		padding-left: 0;
	}
}

.v-title {
	font-size: 16px;
	font-family: "Nunito Sans Light";
	text-align: left;
	margin-right: 0;
	margin-top: 0;
	margin-bottom: 0;
	color: white;
	width: 100%;

	.v-content {
		font-size: 16px;
		color: #fdfdfd;
		font-family: "Nunito Sans Regular" !important;
		float: right;
		margin-left: -10px;
		padding-left: 0;
	}
}

.switch {
	position: relative;
	display: inline-block;
	width: 40px;
	height: 24px;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #20bfaa;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}
.slider:before {
	position: absolute;
	content: "";
	height: 20px;
	width: 20px;
	left: 2px;
	bottom: 2px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input:checked + .slider {
	background-color: #2092bf;
}

input:focus + .slider {
	box-shadow: 0 0 1px #2092bf;
}

input:checked + .slider:before {
	-webkit-transform: translateX(18px);
	-ms-transform: translateX(18px);
	transform: translateX(18px);
}

.usage-power-info {
	box-shadow: 10px 10px #71d3ba, -10px -10px #71d3ba, 0px 0px 5px 5px #b9e1f9;
	padding: 10px;
	width: 260px;
	background: #04141e;
}
.switch-info {
	margin: 0 auto;
	background-color: #1e365d;
	color: #ffffff;
	opacity: 0.9;
	border-radius: 4px;
	border: 1px solid #fdfdfd;
	padding: 10px;

	.chart-type {
		padding: 0 30px;
		text-transform: uppercase;
		font-weight: 100;
		font-family: "Nunito Sans Light";
		opacity: 0.6;
	}

	.chart-type.active-chart {
		opacity: 1;
	}
}

.select-text {
	text-transform: capitalize;
	color: #20bfaa;
	font-weight: 300;
	font-family: "Nunito Sans Regular";
	cursor: pointer;
	text-decoration: underline;
}

.timepicker p {
	margin-bottom: 5px;
}

.checkbox-panel {
	background-color: #1e365d;
	border: 1px solid #fdfdfd;
	border-radius: 5px;
	padding: 15px;
	max-width: 220px;
}
.ps {
	height: 150px;

	.ps__rail-y {
		background: #1e365d !important;
	}
}
.vc-popover-content.direction-bottom.vc-container.vc-is-dark {
	background-color: #1e365d !important;
}

.filter-text {
	width: max-content;
	font-weight: 100;
	font-family: "Nunito Sans Light";
	color: #fdfdfd;
}

.ct-title {
	text-transform: uppercase;
	text-align: center;
	color: rgba(252, 252, 252, 0.7);
	font-size: 16px;
}
</style>
